import AppMenu from './AppMenu'

export default function HeaderWide({ title }) {
  return (
    <>
      <div className="bg-cyan-800 dark:bg-gray-800">
        <AppMenu />
      </div>
    </>
  )
}

